<div class="statistics-chart-card">
  <div class="chart-header">
    <h3 class="chart-title">{{ title }}</h3>
  </div>

  <div class="chart-body">
    <div *ngIf="loading" class="chart-loading">
      <i class="pi pi-spin pi-spinner text-2xl text-gray-400"></i>
      <p class="text-sm text-gray-500 mt-2">{{ 'STATISTICS.LOADING' | translate }}</p>
    </div>

    <div *ngIf="!loading && !hasData" class="chart-empty">
      <i class="pi pi-chart-bar text-3xl text-gray-300"></i>
      <p class="text-sm text-gray-500 mt-2">{{ emptyMessage || ('STATISTICS.NO_DATA' | translate) }}</p>
    </div>

    <div *ngIf="!loading && hasData" class="chart-container" [style.height]="height">
      <p-chart [type]="chartType" [data]="chartData" [options]="chartOptions" [style.height]="height"></p-chart>
    </div>
  </div>
</div>